export default __webpack_public_path__ + "static/media/built-by-tomorrow.e8ad592f.svg";